import axios from "axios";
// import {Message} from 'element-ui';
import { Toast } from "vant";
import { getSigndata } from "./signUrl.js";

// http://leadergzh.tailgvip.com
// http://47.97.251.141:8081

const service = axios.create({
    baseURL: process.env.VUE_APP_SERVER_API,
    // baseURL: 'http://47.97.251.141:8082/api',
    timeout: 15 * 1000, // 15s
    method: "POST",
});
service.interceptors.request.use(
    (config) => {
        const encrypt = getSigndata(config);
        let token = localStorage.getItem("appToken");
        if (token) {
            config.headers.authorization = token;
        }
        config.headers = {
            ...config.headers,
            ...encrypt,
        };
        return config;
    },
    (error) => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    (response) => {
        if (response.config.responseType === "blob") {
            return response.data;
        }
        if (response.data.status === 0 || response.data.status || response.data.Status || response.data.code === 1) {
            return response.data;
        } else {
            console.log(response);
            Toast.fail(response.data.message || response.data.Message || "未知错误");
            return Promise.reject(response.data);
        }
    },
    (error) => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;
